<!-- Header Section -->
<div *ngIf="!loadSite" class="loader-container">
  <img [src]="loaderIcon" alt="Loading..." class="loader">
  <div class="loader-text">Loading...</div>
</div>
<div *ngIf="loadSite && !isSystemDown" class="header-block gradient-bg" [class.dark-theme]="selectedTheme === 'dark'">
  <div class="chat-header-section">
    <img [src]="selectedTheme === 'dark' ? cognizantDarkLogo : cognizantLogo" alt="Cognizant Logo"
      class="cognizant-logo" (click)="reloadApp()">
    <!-- <button pButton label="Open Session Timeout Popup" (click)="showSessionPopup()"></button> -->
  </div>
  <div class="chat-header-section">
    <div class="header-right-block">
      <div (click)="startNewCheckIn()" class="check-in-progression" *ngIf="!showPopup2TemporaryScreen">
        <div class="progress-head">
          <div class="ph-title">{{ progressionTitle }}</div>
          <div class="checkIn-count-message">{{totalCheckInsCount}} Total</div>
        </div>
        <div class="check-in-progress-bar">
          <div class="progress" [style.width.%]="checkInProgressPercent"></div>
        </div>
        <div class="progress-tail">
          <div class="completed">{{completedCheckInsCount}} completed</div>
          <div class="total">{{pendingCheckInsCount}} Pending</div>
        </div>
      </div>
      <!-- <div class="check-in-metric">
          Daily Check-Ins<span class="checkIn-count">{{completedCheckInsCount}}/{{totalCheckInsCount}}</span>
          <div class="check-in-tooltip">
            Daily Check-Ins: {{completedCheckInsCount}} completed / {{totalCheckInsCount}} Total
          </div>
        </div> -->
      <div class="action-point" (click)="showCheckInHistory()" *ngIf="!showPopup2TemporaryScreen">
        <img class="default-icon" [src]="historyIcon" alt="History Icon" />
        <img class="hover-icon" [src]="historyIconHover" alt="History Icon" />
        Check-in History
      </div>
      <div class="theme-setting-block">
        <div class="theme-icon-wrapper" (click)="setTheme('light')">
          <img [src]="lightThemeDisplayIcon" alt="Light theme">
        </div>
        <div class="theme-icon-wrapper" (click)="setTheme('dark')">
          <img [src]="darkThemeDisplayIcon" alt="Dark theme">
        </div>
      </div>
      <div (click)="confirmLogout = true;" class="action-point logout-btn">
        <img class="default-icon" [src]="logoutDisplayIcon" alt="Logout Icon" />
        <img class="hover-icon" [src]="logoutIconHover" alt="Logout Icon" />
        Logout
      </div>
    </div>
  </div>
</div>
<div *ngIf="loadSite && !isSystemDown && !showPopup2TemporaryScreen" class="mainContent-container gradient-bg"
  [class.dark-theme]="selectedTheme === 'dark'">
  <!-- Project/ProcessToolbar -->
  <div *ngIf="projectSelected && processSelected" class="toolbar-section gradient-bg"
    [class.dark-theme]="selectedTheme === 'dark'">
    <div class="title-card">
      {{ getCurrentProjectName() }}
      <i class="dot-seperator fa fa-circle"></i>
      {{ getCurrentProcessName() }}
      <i class="dot-seperator fa fa-circle"></i>
      {{ currentProcessDetails?.LocationName }}
    </div>
    <div class="toolbar-actions">
      <div class="toolbar-info">
        Today's Issues <span class="issue-count">{{ todayIssuesCount }}</span>
      </div>
      <div class="toolbar-action" [class.active]="processDetailsShow === true && sidebarExpanded === true"
        (click)="showProcessDetails();">
        <img [src]="processDetailsIcon" alt="Process Details Icon" class="darkIcon" />
        <img [src]="processDetailsLightIcon" alt="Process Details Light Icon" class="lightIcon" />
        Process Details
      </div>
    </div>
  </div>

  <div class="chatPage-container gradient-bg" [class.dark-theme]="selectedTheme === 'dark'">
    <!-- Main Chat Section -->
    <div class="main-panel" [ngStyle]="{'flex': sidebarExpanded ? '0 0 75%' : '0 0 100%'}">
      <!-- Your existing chat HTML goes here -->
      <div class="container-fluid gradient-bg" [class.dark-theme]="selectedTheme === 'dark'">
        <div class="row chat-main-row">
          <div class="offset-md-1 col-md-10 chat-body-container">
            <div class="chat-body-section" #scrollContainer>
              <div class="chat-body-content">
                <div class="chat-container">
                  <!-- Welcome Messages -->
                  <div *ngIf="showWelcomeMessages" class="message bot-message welcome-message-wrapper">
                    <img [src]="chatBotIcon" class="profile-pic" alt="Bot">
                    <div class="message-content-wrapper">
                      <div *ngFor="let welcomeMessage of welcomeMessages" class="message-content welcome-message">
                        {{ welcomeMessage }}
                      </div>
                      <div class="project-process-dropdown">
                        <div class="selectBox">
                          <select class="project-dropdown" [(ngModel)]="selectedProject"
                            (change)="onProjectChange($event)" [disabled]="projectLocked">
                            <option value="" disabled selected>Select Project</option>
                            <option *ngFor="let option of projectOptions" [value]="option.value"
                              [class.completed-project]="option.status === 'completed'" [title]="option.status === 'completed' ? 'Completed Project' : ''">
                              {{ option.label }}
                            </option>
                          </select>
                          <!-- <div class="select-icon">
                            <i class="fa-solid fa-chevron-down"></i>
                          </div> -->
                        </div>
                        <div class="selectBox">
                          <select *ngIf="showProcessSelection" class="process-dropdown" [(ngModel)]="selectedProcess"
                            (change)="onProcessChange($event)" [disabled]="processLocked">
                            <option value="" disabled selected>Select Process</option>
                            <option *ngFor="let option of processOptions" [value]="option.value"
                              [class.completed-process]="option.status === 'completed'" [title]="option.status === 'completed' ? 'Completed Process' : ''">
                              {{ option.label }}
                              <!-- <img *ngIf="option.status === 'completed'" [src]="completedIcon" alt="Completed" class="status-icon">
                              <img *ngIf="option.status === 'pending'" [src]="pendingIcon" alt="Pending" class="status-icon"> -->
                            </option>
                          </select>
                          <!-- <div class="select-icon" *ngIf="showProcessSelection">
                            <i class="fa-solid fa-chevron-down"></i>
                          </div> -->
                        </div>
                      </div>
                      <div class="bot-meta">IOAPulseAgent {{ welcomeTimeStamp }}</div>
                    </div>
                  </div>
                  <div *ngIf="!showWelcomeMessages && !conversationStarted && showWelcomeMessagesError"
                    class="message bot-message welcome-message-wrapper">
                    <img [src]="chatBotIcon" class="profile-pic" alt="Bot">
                    <div class="message-content-wrapper">
                      <div *ngFor="let welcomeMessageError of welcomeMessageErrors"
                        class="message-content welcome-message msg-error">
                        {{ welcomeMessageError }}
                      </div>
                      <div class="bot-meta">IOAPulseAgent {{ welcomeTimeStamp }}</div>
                    </div>
                  </div>
                  <div class="projectProcessBanner" *ngIf="conversationStarted || isHoliday">
                    <div class="conversation-started-label">
                      <span>You've selected the following Project : Process</span>
                    </div>
                    <div class="selected-project-process">
                      <div class="project-process-tag">
                        {{ getCurrentProjectName() }}
                        <i class="dot-seperator fa fa-circle"></i>
                        {{ getCurrentProcessName() }}
                        <i class="dot-seperator fa fa-circle"></i>
                        {{ currentProcessDetails?.LocationName }}
                      </div>
                    </div>
                  </div>
                  <div *ngIf="isHoliday" class="holiday-down-content">
                    <div class="title">Check-in is inactive today</div>
                    <div>
                      <img [src]="holidayIcon" alt="Holiday" class="holiday-icon">
                      <div class="shadow"></div>
                    </div>
                    <div class="holiday-detail">Holiday : {{ holidayDate }} - {{ holidayName }}</div>
                  </div>
                  <!-- Chat Messages -->
                  <div *ngFor="let message of messages; let i = index" class="message"
                    [ngClass]="{'user-message': message.sender === 'user', 'bot-message': message.sender === 'bot'}">
                    <img *ngIf="message.sender === 'bot' && (!message.botIcon || message.botIcon !== 'no')"
                      [src]="chatBotIcon" class="profile-pic" alt="Bot">
                    <div *ngIf="message.sender === 'bot' && message.botIcon && message.botIcon === 'no'"
                      class="no-botIcon"></div>
                    <div class="message-content-wrapper" *ngIf="message.type === 'message'">
                      <div class="">
                        <markdown class="message-content"
                        [ngClass]="{'highlight': message.highlight, 'error-text': message.isError}"
                        [data]="message.content"></markdown>
                        <div *ngIf="message.sla && message.sla.length && message.sender === 'bot'" class="sla-block">
                          <div *ngFor="let slaItem of message.sla" class="sla-item" (click)="selectSLA(slaItem.id, i)">
                            <div class="sla-title-portion">
                              <div class="sla-title">{{ slaItem.title }}</div>
                              <div class="sla-due-time">
                                <img [src]="calendarIcon" alt="Calendar" class="calendar-icon">
                                {{ slaItem.due_time }}
                              </div>
                            </div>
                            <div class="sla-status-portion">
                              <div [ngClass]="'sla-status ' + slaItem.reason_status">
                                <img *ngIf="slaItem.reason_status === 'pending'" [src]="pendingSlaIcon" alt="Pending" class="status-icon">
                                <img *ngIf="slaItem.reason_status === 'added'" [src]="addedSlaIcon" alt="Added" class="status-icon">
                                Reason {{ slaItem.reason_status }}
                              </div>
                              <div>
                                <img *ngIf="isSLASelected(slaItem.id)" [src]="slaSelectedIcon" alt="Selected" class="status-icon">
                              </div>
                            </div>
                            <div class="sla-reason">{{ slaItem.reason }}</div>
                          </div>
                          <div class="sla-update-block">
                            <div class="sla-update-title-portion">
                              <div class="sla-update-title">Add / Update Reason</div>
                              <div *ngIf="selectedSLA.length > 0" class="sla-selection-count">
                                {{ selectedSLA.length }} SLA Selected
                              </div>
                            </div>
                            <div class="sla-textarea-block">
                              <textarea rows="3" pTextarea [(ngModel)]="slaReasonText" [disabled]="selectedSLA.length === 0" resizable="false" appNohtml></textarea>
                            </div>
                            <div class="sla-action-button-block">
                              <button class="sla-cancel-button" (click)="clearSlaReason()">Cancel</button>
                              <button class="sla-action-button" (click)="updateSlaReason()" [disabled]="selectedSLA.length === 0 || !slaReasonText || slaReasonText.trim() === ''">Save</button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="message.sender === 'bot' && message.timestamp" class="bot-meta">
                        IOAPulseAgent {{ message.timestamp }}
                      </div>
                      <div *ngIf="message.sender === 'user' && message.timestamp" class="user-meta">
                        {{userName || 'User'}} {{ message.timestamp }}
                      </div>
                      <div *ngIf="message.sender === 'bot' && message.replyPrompts && message.replyPrompts.length > 0"
                        class="reply-prompts">
                        <button *ngFor="let prompt of message.replyPrompts" class="reply-prompt-button"
                          (click)="handleReplyPrompt(prompt, i)" [disabled]="message.replied">{{ prompt }}</button>
                        <!-- <button class="reply-prompt-button" (click)="handleReplyPrompt('yes', i)" [disabled]="message.replied">Yes</button>
                        <button class="reply-prompt-button" (click)="handleReplyPrompt('no', i)" [disabled]="message.replied">No</button> -->
                      </div>
                    </div>
                    <div class="conversationSummaryContent" *ngIf="message.type === 'table'">
                      <div *ngIf="message.editable === false" class="p-table-container">
                        <div class="p-table-wrapper">
                        <p-table [value]="message?.oldContent" [scrollable]="true" class="conv-summary-table">
                          <ng-template #header>
                            <tr class="bg-gradient">
                              <th class="width100">Log/ Update</th>
                              <th class="width100">Reason</th>
                              <th class="font-bold width100">Issue ID</th>
                              <th class="width200">Issue Statement</th>
                              <th class="width200">Issue Description</th>
                              <th class="width200">Current State</th>
                              <th class="width200">Business Impact</th>
                              <th>Impact Area</th>
                              <th>Severity</th>
                              <th>Revenue Impact<div class="hinting">(in Million$)</div>
                              </th>
                              <th>Margin Impact<div class="hinting">(in Million$)</div>
                              </th>
                              <th>FTE</th>
                            </tr>
                          </ng-template>
                          <ng-template #body let-completedSummaryItem>
                            <tr>
                              <td>{{ completedSummaryItem?.flag ? getIssueType(completedSummaryItem?.flag) :
                                getIssueType(completedSummaryItem?.action) }}</td>
                              <td class="width100">{{ getReasonLabel(completedSummaryItem.reason_id) }}</td>
                              <td class="font-bold width100">{{ completedSummaryItem.issue_id }}</td>
                              <td class="width200">
                                <div class="scroll100">{{ completedSummaryItem.risk_statement || '-' }}</div>
                              </td>
                              <td class="width200">
                                <div class="scroll100">{{ completedSummaryItem.risk_description || '-' }}</div>
                              </td>
                              <td class="width200">
                                <div class="scroll100">{{ completedSummaryItem.current_state || '-' }}</div>
                              </td>
                              <td class="width200">
                                <div class="scroll100">{{ completedSummaryItem.business_impact || '-' }}</div>
                              </td>
                              <td>{{ getImpactAreaLabel(completedSummaryItem.impact_id) }}</td>
                              <td>{{ getSeverityLabel(completedSummaryItem.risk_severity) }}</td>
                              <td>{{ completedSummaryItem.revenue_impact }}</td>
                              <td>{{ completedSummaryItem.margin_impact }}</td>
                              <td>{{ completedSummaryItem.fte }}</td>
                            </tr>
                          </ng-template>
                          <ng-template #emptymessage>
                            <tr>
                              <td colspan="12" class="text-left">No issues were summarized in this check-in.</td>
                            </tr>
                          </ng-template>
                        </p-table>
                        </div>
                        <div *ngIf="message.timestamp" class="bot-meta">
                          IOAPulseAgent {{ message.timestamp }}
                        </div>
                        <div *ngIf="message?.oldContent.length === 0" class="action-button-wrapper">
                          <button *ngIf="!conversationClosed && showContinueChat" class="action-link" (click)="continueChat()">Continue Chat</button>
                        </div>
                      </div>
                      <div *ngIf="message.editable === true" class="p-table-container">
                        <div class="p-table-wrapper">
                        <p-table [value]="message?.content" [scrollable]="true" class="conv-summary-table">
                          <ng-template #header>
                            <tr class="bg-gradient">
                              <th pFrozenColumn class="width50"></th>
                              <th class="width100">Log/ Update</th>
                              <th>Reason</th>
                              <th class="font-bold width100">Issue ID</th>
                              <th class="width200">Issue Statement</th>
                              <th class="width200">Issue Description</th>
                              <th class="width200">Current State</th>
                              <th class="width200">Business Impact</th>
                              <th>Impact Area</th>
                              <th>Severity</th>
                              <th>Revenue Impact<div class="hinting">(in Million$)</div>
                              </th>
                              <th>Margin Impact<div class="hinting">(in Million$)</div>
                              </th>
                              <th>FTE</th>
                            </tr>
                          </ng-template>
                          <ng-template #body let-editSummaryItem let-editing="editing" let-ri="rowIndex">
                            <tr [pEditableRow]="editSummaryItem" [ngClass]="{'editing-row': selectedIssueId === editSummaryItem.issue_id}">
                              <td pFrozenColumn>
                                <div class="flex items-center justify-center gap-2">
                                  <button *ngIf="selectedIssueId !== editSummaryItem.issue_id" pButton pRipple type="button" pInitEditableRow
                                    icon="pi pi-pencil" text rounded severity="secondary" pTooltip="Edit Issue"
                                    pTooltipPosition="top" (click)="startEditing(editSummaryItem)"></button>
                                  <button *ngIf="selectedIssueId === editSummaryItem.issue_id" pButton pRipple type="button" pCancelEditableRow
                                    icon="pi pi-times" text rounded severity="secondary" pTooltip="Close Edit"
                                    pTooltipPosition="top" (click)="cancelEditing(i, ri)"></button>
                                </div>
                              </td>
                              <td>{{ getIssueType(editSummaryItem.flag) }}</td>
                              <td>{{ getReasonLabel(editSummaryItem.reason_id) }}</td>
                              <td class="font-bold">{{ editSummaryItem.issue_id }}</td>
                              <td>
                                @if (isUpdatedFlag(editSummaryItem.flag)) {
                                  {{ editSummaryItem.risk_statement || '-' }}
                                } @else {
                                  <div class="scroll100">
                                    {{ editSummaryItem.risk_statement || '-' }}
                                  </div>
                                }
                              </td>
                              <td>
                                <div class="scroll100">
                                  {{ editSummaryItem.risk_description || '-' }}
                                </div>
                              </td>
                              <td>
                                <div class="scroll100">
                                  {{ editSummaryItem.current_state || '-' }}
                                </div>
                              </td>
                              <td>
                                <div class="scroll100">
                                  {{ editSummaryItem.business_impact || '-' }}
                                </div>
                              </td>
                              <td>
                                @if (isUpdatedFlag(editSummaryItem.flag)) {
                                  {{ getImpactAreaLabel(editSummaryItem.impact_id) }}
                                } @else {
                                  {{ getImpactAreaLabel(editSummaryItem.impact_id) }}
                                }
                              </td>
                              <td>
                                @if (isUpdatedFlag(editSummaryItem.flag)) {
                                  {{ getSeverityLabel(editSummaryItem.risk_severity) }}
                                } @else {
                                  {{ getSeverityLabel(editSummaryItem.risk_severity) }}
                                }
                              </td>
                              <td>{{ editSummaryItem.revenue_impact }}</td>
                              <td>{{ editSummaryItem.margin_impact }}</td>
                              <td>{{ editSummaryItem.fte }}</td>
                            </tr>
                          </ng-template>
                        </p-table>
                        </div>
                        <div class="action-button-wrapper">
                          <!-- <button *ngIf="conversationEdited" class="action-button" (click)="saveConversationSummary()">Save Changes</button> -->
                          <button *ngIf="!conversationClosed && showContinueChat" class="action-link" (click)="continueChat()">Continue Chat</button>
                        </div>
                        <div *ngIf="summaryValidationError" class="summaryValidationError">{{summaryValidationErrorMsg}}</div>
                        <div *ngIf="message.timestamp" class="bot-meta">
                          IOAPulseAgent {{ message.timestamp }}
                        </div>
                      </div>
                    </div>
                    <img *ngIf="message.sender === 'user'" [src]="userProfilePic" class="profile-pic" alt="User">
                  </div>
                  <div *ngIf="isBotTyping" class="message bot-message">
                    <img [src]="chatBotIcon" class="profile-pic" alt="Bot">
                    <div class="loader-wrapper">
                      <img [src]="typingLoader" alt="Typing..." class="typing-loader">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="chat-footer-section">
              <div class="chat-footer-content text-center">
                <div class="conversationClosed" *ngIf="conversationClosed">
                  <div class="conversation-closed-label">
                    <span>Conversation ended here</span>
                  </div>
                  <div class="next-checkins" *ngIf="nextProcessDetails && nextProjectDetails">
                    <div class="next-checkin-title">Next Assigned Check-Ins</div>
                    <div class="next-actions">
                      <div class="project-details">
                        <div class="project-name">{{ nextProjectDetails?.ProjectName }}</div>
                        <div class="process-name">{{ nextProcessDetails?.ProcessName }}</div>
                      </div>
                      <div class="next-actions">
                        <button class="action-button" (click)="startNextCheckIn()">Start Next <i
                            class="fa-solid fa-chevron-right"></i></button>
                        <button class="action-button" (click)="startNewCheckIn()">Select Next <i
                            class="fa-solid fa-chevron-right"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="!conversationClosed && conversationStarted">
                  <!-- <div *ngIf="showIssueOpener" class="issues-opener-block">
                      <div class="issues-opener-content">
                        <div class="issues-opener-subtitle">You have open issues in this check-in.</div>
                        <button class="action-button" (click)="openSummaryTable()">View Open Issues</button>
                        <img [src]="closeIcon" alt="Close" (click)="closeIssueOpener()">
                      </div>
                  </div> -->
                  <div *ngIf="showIssueOpener" class="issues-opener-block">
                      <div class="issues-opener-content">
                        <div class="issues-opener-subtitle">Click <a (click)="openSummaryTable()">here</a> to view the issues to be logged after check-in closes</div>
                        <!-- <button class="action-button" (click)="openSummaryTable()">View Open Issues</button> -->
                        <img [src]="closeIcon" alt="Close" (click)="closeIssueOpener()">
                      </div>
                  </div>
                  <div class="textarea-container"
                    [class.focused]="isFocused" [class.disabled]="conversationClosed || isConnectionLost">
                    <textarea class="chat-text-area" name="" id="" cols="30" rows="1" #chatInput
                      (input)="adjustTextareaHeight(chatInput)" [attr.rows]="currentRows" (focus)="isFocused = true"
                      (blur)="isFocused = false" [placeholder]="!conversationClosed ? 'Type your message here' : ''"
                      [(ngModel)]="userTextMessage" (keydown.enter)="sendMessage($event)" (blur)="isFocused = false"
                      appNohtml></textarea>
                    <div class="action-icons">
                      <!-- <img [src]="selectedTheme === 'dark' ? micIconDark : micIcon" alt="Mic" class="icon"> -->
                      <div class="send-icon-wrapper" [class.active]="isFocused" (click)="sendMessage()">
                        <img [src]="selectedTheme === 'dark' ? sendIconDark : sendIcon" alt="Send"
                          class="icon send-icon-default">
                        <img [src]="selectedTheme === 'dark' ? sendIconDarkActive : activeSendIcon" alt="Send"
                          class="icon send-icon-active">
                      </div>
                    </div>
                    <!-- <div *ngIf="userTextMessage && userTextMessage.length >= chatCharacterLimit" class="char-limit-msg">
                      Maximum {{ chatCharacterLimit }} characters allowed.
                    </div> -->
                  </div>
                </div>
                <span *ngIf="conversationStarted" class="genai-aware-text">
                  GenAI may make mistakes. Please verify important information.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Right Sidebar -->
    <!-- Right Sidebar (Expanded Dark Theme) -->
    <div *ngIf="sidebarExpanded" class="right-sidebar" [ngStyle]="{'flex': sidebarExpanded ? '0 0 25%' : '0 0 0%'}"
      [class.dark-theme]="selectedTheme === 'dark'">

      <!-- Collapsed Header -->
      <!-- <div *ngIf="!sidebarExpanded" class="sidebar-header">
        <img [src]="selectedTheme === 'dark' ? rightPanelExpansionIconDark : rightPanelExpansionIconLight" alt="Expand"
          class="expansion-icon" (click)="sidebarExpanded = true">
      </div> -->

      <div>

        <!-- Expanded Header -->
        <div class="right-main-header-block">
          <!-- Left Header Block -->
          <div class="left-header-block-right-panel">
            <div *ngIf="processDetailsShow && !showHistoryTabs && !showSummaryTableEditing">
              <div class="header-heading">Process Details</div>
            </div>
            <div *ngIf="!processDetailsShow && showHistoryTabs && !showSummaryTableEditing">
              <div class="header-heading">Today's Check-Ins</div>
              <div class="header-subheading">{{ currentDayDate }}</div>
            </div>
            <div *ngIf="!processDetailsShow && !showHistoryTabs && showSummaryTableEditing">
              <div class="header-heading"><span class="issue-bg">Issue</span><span> #{{ selectedIssueId }}</span></div>
              <div class="header-subheading">
                <img [src]="circleBlink" alt="edit here" class="edit-here-icon">
                Edit the required values
              </div>
            </div>
          </div>

          <!-- Right Header Block -->
          <div class="right-header-block-right-panel">
            <div class="close-icon" (click)="onSidebarClose()">
              <img [src]="closeIcon" alt="Close">
            </div>
          </div>
        </div>

        <!-- Expanded Content Section -->
        <div class="sidebar-content">
          <!-- Process Details -->
          <div *ngIf="processDetailsShow && !showHistoryTabs && !showSummaryTableEditing" class="details-container"
            [class.dark-theme]="selectedTheme === 'dark'" [class.light-theme]="selectedTheme === 'light'">
            <div class="detail">
              <div class="label">Location</div>
              <div class="value">{{ currentProcessDetails?.LocationName || '-' }}</div>
            </div>
            <div class="detail">
              <div class="label">Billed FTE Count</div>
              <div class="value">{{ currentProcessDetails?.BilledFTECount || '-' }}</div>
            </div>
            <div class="detail full-width">
              <div class="label">Primary FLM</div>
              <div class="value">{{ currentProcessDetails?.FLM || '-' }} {{currentProcessDetails?.FLMId ? '(' +
                currentProcessDetails?.FLMId + ')' : ''}}</div>
            </div>
            <div class="detail full-width">
              <div class="label">Proxy FLM</div>
              <div class="value">{{ currentProcessDetails?.ProxyFLM || '-' }} {{currentProcessDetails?.ProxyFLMId ? '('
                + currentProcessDetails?.ProxyFLMId + ')' : ''}}</div>
            </div>
            <div class="detail full-width">
              <div class="label">Supervisor</div>
              <div class="value">{{ currentProcessDetails?.Supervisor || '-' }} {{currentProcessDetails?.SupervisorId ?
                '(' + currentProcessDetails?.SupervisorId + ')' : ''}}</div>
            </div>
            <div class="detail full-width">
              <div class="label">Service Line</div>
              <div class="value">{{ currentProcessDetails?.ServiceLine || '-' }}</div>
            </div>
            <div class="detail">
              <div class="label">FTE Count</div>
              <!-- <div class="value">{{ currentProcessDetails?.FTECount || '-' }}</div> -->
              <div class="field-container">
                <input type="number" class="text-box" [(ngModel)]="fteCount" id="fteCount" autocomplete="false"
                  (keydown)="clearFTEerror()" [disabled]="isHoliday" />
                <button *ngIf="!isHoliday" class="update-btn" (click)="FTEupdateConfirmation = true;"
                  [disabled]="disableFTECountUpdate()">Update</button>
                <div *ngIf="fteCountUpdateError" class="error-msg">FTE Count Not Updated!</div>
                <div *ngIf="fteCountUpdated" class="success-msg">FTE Count Updated.</div>
              </div>
              <p-dialog header="Are you sure!" [modal]="true" [(visible)]="FTEupdateConfirmation"
                class="FTEcount-update-confirmation" [style]="{ width: '25rem' }">
                <span class="p-text-secondary block mb-8">You want to update the FTE count?</span>
                <div class="btn-container">
                  <p-button label="Cancel" severity="secondary" (click)="cancelFTEUpdate()" />
                  <p-button label="Update" severity="success"
                    (click)="FTEupdateConfirmation = false; updateFTECount()" />
                </div>
              </p-dialog>
            </div>
            <div class="detail">
              <div class="label">Billing Type</div>
              <div class="value">{{ currentProcessDetails?.BillingType || '-' }}</div>
            </div>
            <div class="detail full-width">
              <div class="label">Holiday Calendar</div>
              <div class="dropdown">
                <select>
                  <option *ngIf="!holidays || holidays.length === 0" value="" disabled selected>No Holiday Data!
                  </option>
                  <option *ngFor="let holiday of holidays" [value]="holiday.HolidayCalendarId">
                    {{ holiday.HolidayDescription }} - {{ formatHolidayDate(holiday.CalendarDate) }}
                  </option>
                </select>
              </div>
            </div>
            <div class="detail full-width">
              <div class="label">Check-In Start / End</div>
              <div class="value date-value">
                {{ formatTimestamp(currentProcessDetails?.CheckInStart) }}
                <br>
                / {{ formatTimestamp(currentProcessDetails?.CheckInEnd) }}
              </div>
            </div>
          </div>

          <!-- History Tabs -->
          <div class="full-width" *ngIf="showHistoryTabs && !processDetailsShow && !showSummaryTableEditing">
            <div *ngIf="historyLoader" class="history-loader-wrapper">
              <img [src]="historyLoaderIcon" alt="Loading Check-Ins..." class="history-loader">
              <div class="loading-text">Loading Check-Ins...</div>
            </div>
            <div *ngIf="!historyLoader && !noHistory" class="history-container"
              [class.dark-theme]="selectedTheme === 'dark'" [class.light-theme]="selectedTheme === 'light'">
              <div class="history-tabs">
                <button class="history-tab" type="button" [class.active]="activeHistoryTab === 'in-progress'"
                  (click)="setHistoryTab('in-progress')">In Progress</button>
                <button class="history-tab" type="button" [class.active]="activeHistoryTab === 'completed'"
                  (click)="setHistoryTab('completed')">Completed</button>
              </div>
              <div class="history-tab-panel">
                <div *ngIf="activeHistoryTab === 'in-progress'" class="history-list">
                  <div *ngFor="let item of inprogressHistory" (click)="openProcess(item)" class="history-item"
                    [class.active]="isActiveHistoryItem(item)">
                    <div class="history-project-block">
                      <div class="history-project-details">
                        <div class="history-project">
                          <span pTooltip="{{ item.project_name }}" tooltipPosition="top">{{ item.project_name }}</span>
                        </div>
                        <div class="history-process">
                          <span pTooltip="{{ item.process_name + ' - ' + item.location_name }}" tooltipPosition="top">
                            {{ item.process_name + ' - ' + item.location_name }}
                          </span>
                        </div>
                      </div>
                      <div class="history-status in-progress">{{ item.status }}</div>
                    </div>
                    <div class="history-comments">{{ item.conversation_summary }}</div>
                  </div>
                  <div *ngIf="!inprogressHistory || inprogressHistory.length === 0" class="no-history-item">
                    <div class="no-history-container" [class.dark-theme]="selectedTheme === 'dark'"
                      [class.light-theme]="selectedTheme === 'light'">
                      <img [src]="noHistoryIcon" alt="No History" class="no-history-icon">
                      <div class="no-history-text">No check-ins are in progress yet</div>
                      <div class="suggestion-text">Select a Project/Process for check-in to start.</div>
                    </div>
                  </div>
                </div>
                <div *ngIf="activeHistoryTab === 'completed'" class="history-list">
                  <div *ngFor="let item of completedHistory" (click)="openProcess(item, 'completed')"
                    class="history-item" [class.active]="isActiveHistoryItem(item)">
                    <div class="history-project-block">
                      <div class="history-project-details">
                        <div class="history-project">
                          <span pTooltip="{{ item.project_name }}" tooltipPosition="top">{{ item.project_name }}</span>
                        </div>
                        <div class="history-process">
                          <span pTooltip="{{ item.process_name + ' - ' + item.location_name }}" tooltipPosition="top">
                            {{ item.process_name + ' - ' + item.location_name }}
                          </span>
                        </div>
                      </div>
                      <div class="history-status completed">{{ item.status }}</div>
                    </div>
                    <div class="history-comments">{{ item.conversation_summary }}</div>
                  </div>
                  <div *ngIf="!completedHistory || completedHistory.length === 0" class="no-history-item">
                    <div class="no-history-container" [class.dark-theme]="selectedTheme === 'dark'"
                      [class.light-theme]="selectedTheme === 'light'">
                      <img [src]="noHistoryIcon" alt="No History" class="no-history-icon">
                      <div class="no-history-text">No check-ins are completed yet</div>
                      <div class="suggestion-text">Select a Project/Process for check-in to complete.</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!historyLoader && noHistory && !historyError" class="no-history-container"
              [class.dark-theme]="selectedTheme === 'dark'" [class.light-theme]="selectedTheme === 'light'">
              <img [src]="noHistoryIcon" alt="No History" class="no-history-icon">
              <div class="no-history-text">No check-ins are initiated yet</div>
              <div class="suggestion-text">Select a Project/Process for check-in to open a new tab.</div>
            </div>
            <div *ngIf="!historyLoader && historyError" class="no-history-container"
              [class.dark-theme]="selectedTheme === 'dark'" [class.light-theme]="selectedTheme === 'light'">
              <img [src]="noHistoryIcon" alt="No History" class="no-history-icon">
              <div class="no-history-text">Failed to fetch history!</div>
              <div class="suggestion-text">Please try refreshing the page or check back later.</div>
            </div>
          </div>

          <!-- Summary Table Editor -->
          <div class="full-width" *ngIf="!showHistoryTabs && !processDetailsShow && showSummaryTableEditing">
            <div class="issue-editing-block">
              <div class="input-item">
                <div class="width100">
                  <div class="label">Issue Statement</div>
                  <textarea (ngModelChange)="conversationRowChanged()" class="width100" rows="3" pTextarea [(ngModel)]="editSummaryItem.risk_statement" appNohtml></textarea>
                </div>
              </div>
              <div class="input-item">
                <div class="width100">
                  <div class="label">Issue Description</div>
                  <textarea (ngModelChange)="conversationRowChanged()" class="width100" rows="6" pTextarea [(ngModel)]="editSummaryItem.risk_description" appNohtml></textarea>
                </div>
              </div>
              <div class="input-item">
                <div class="width100">
                  <div class="label">Current State</div>
                  <textarea (ngModelChange)="conversationRowChanged()" class="width100" rows="3" pTextarea [(ngModel)]="editSummaryItem.current_state" appNohtml></textarea>
                </div>
              </div>
              <div class="input-item">
                <div class="width100">
                  <div class="label">Business Impact</div>
                  <textarea (ngModelChange)="conversationRowChanged()" class="width100" rows="6" pTextarea [(ngModel)]="editSummaryItem.business_impact" appNohtml></textarea>
                </div>
              </div>
              <div class="input-item">
                <div class="width50">
                  <div class="label">Impact Area</div>
                  <p-select (ngModelChange)="conversationRowChanged()" [options]="impactAreaOptions" appendTo="body"
                      [(ngModel)]="editSummaryItem.impact_id" [disabled]="isUpdatedFlag(editSummaryItem.flag)">
                  </p-select>
                </div>
                <div class="width50">
                  <div class="label">Severity</div>
                  <p-select (ngModelChange)="conversationRowChanged()" class="width100" [options]="severityOptions" appendTo="body"
                      [(ngModel)]="editSummaryItem.risk_severity" [disabled]="isUpdatedFlag(editSummaryItem.flag)">
                  </p-select>
                </div>
              </div>
              <div class="input-item">
                <div class="width50">
                  <div class="label">Revenue Impact(M$)</div>
                  <input (ngModelChange)="conversationRowChanged()" class="width100" pInputText type="text" [(ngModel)]="editSummaryItem.revenue_impact"
                    (keypress)="allowDigitsWithDecimal($event)" (paste)="$event.preventDefault()"
                    (dragover)="preventDragDrop($event)" (drop)="preventDragDrop($event)" />
                </div>
                <div class="width50">
                  <div class="label">Margin Impact(M$)</div>
                  <input (ngModelChange)="conversationRowChanged()" class="width100" pInputText type="text" [(ngModel)]="editSummaryItem.margin_impact"
                    (keypress)="allowDigitsWithDecimal($event)" (paste)="$event.preventDefault()"
                    (dragover)="preventDragDrop($event)" (drop)="preventDragDrop($event)" />
                </div>
              </div>
              <div class="input-item">
                <div class="width50">
                  <div class="label">FTE</div>
                  <input (ngModelChange)="conversationRowChanged()" class="width100" pInputText type="text" [(ngModel)]="editSummaryItem.fte" maxlength="5"
                    (keypress)="allowDigitsOnly($event)" (paste)="$event.preventDefault()"
                    (dragover)="preventDragDrop($event)" (drop)="preventDragDrop($event)" />
                </div>
                <div class="width50">
                  <div class="label">Reason</div>
                  <p-select (ngModelChange)="conversationRowChanged()" [options]="reasonOptions" appendTo="body"
                      [(ngModel)]="editSummaryItem.reason_id" [disabled]="isUpdatedFlag(editSummaryItem.flag)">
                  </p-select>
                </div>
              </div>
              <div class="save-action-block">
                <div *ngIf="summaryValidationError" class="summaryValidationError">{{summaryValidationErrorMsg}}</div>
                <!-- <div class="action-button-wrapper"> -->
                  <button class="cancel-button" (click)="onSidebarClose()">Cancel</button>
                  <button [disabled]="!conversationEdited" class="action-button" (click)="saveConversationSummary()">Save</button>
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>
<div *ngIf="isSystemDown && !showPopup2TemporaryScreen" class="system-down-container">
  <app-system-down></app-system-down>
</div>
<div *ngIf="loadSite && !isSystemDown && showPopup2TemporaryScreen" class="system-down-container">
  <app-popup-down-time [theme]="selectedTheme"></app-popup-down-time>
</div>
<p-dialog header="Are you sure!" [modal]="true" [(visible)]="confirmLogout" class="logout-confirmation"
  [style]="{ width: '25rem' }">
  <span class="p-text-secondary block mb-8">You want to logout?</span>
  <div class="btn-container">
    <p-button label="Cancel" severity="secondary" (click)="confirmLogout = false;" />
    <p-button label="Logout" severity="warn" (click)="confirmLogout = false; logout()" />
  </div>
</p-dialog>
<p-toast></p-toast>
<app-session-timeout-popup [(visibleSessionTimerPopup)]="visibleSessionTimerPopupNext" [popupState]="sessionPopupState"
  (visibleSessionTimerPopupChange)="onPopupClosed()">
</app-session-timeout-popup>